import { PriceFormatter } from 'elc-formatters';
import { diContainer, serviceNames } from '../../../service-setup/diContainer';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';
import { IPriceData } from './Price';

interface IDiscountApplied {
    type: string;
    value: string;
}

// ToDo - if we get following missing data, we can remove this interface and use IPriceDetails
interface IDiscountPriceDetails {
    original_price: number;
    price: number;
    price_per_unit: number;
}

export enum Discounts {
    DISCOUNT_LOYALTY = 'loyalty_sitewide_discount',
    DISCOUNT_SITEWIDE = 'sitewide_discount'
}

export type IDiscountTypes = {
    [key in Discounts]: string;
};

interface IDiscountPrice {
    currency: string;
    include_tax: IDiscountPriceDetails;
    exclude_tax?: IDiscountPriceDetails;
}

export interface IDiscount {
    discount_percent: number;
    discount_applied: IDiscountApplied;
    offer_code: string;
    offer_messaging: string;
    prices: IDiscountPrice[];
}

export interface IDiscountCollection {
    total: number;
    items: IDiscount[];
}

export class Discount {
    private static priceFormatter: PriceFormatter;
    public discountPercent: number;
    public discountApplied: IDiscountApplied;
    public offerCode: string;
    public offerMessaging: string;
    public prices: IPriceData[] = [];

    public constructor() {
        Discount.priceFormatter = diContainer.get(serviceNames.priceFormatter);
    }

    private static priceFromJson(price: IDiscountPrice): IPriceData {
        const priceDetails = price.exclude_tax || price.include_tax;
        const priceDetailsData = {} as IDiscountPriceDetails;

        copyPropertiesExcludeNullsAndGetters(priceDetailsData, priceDetails);

        return {
            currency: price.currency,
            price: priceDetailsData.price,
            priceFormatted: Discount.priceFormatter.formatPriceWithCurrency(priceDetailsData.price),
            originalPrice: priceDetailsData.original_price,
            originalPriceFormatted: Discount.priceFormatter.formatPriceWithCurrency(
                priceDetailsData.original_price
            ),
            pricePerUnit: priceDetailsData.price_per_unit,
            pricePerUnitFormatted: Discount.priceFormatter.formatPriceWithCurrency(
                priceDetailsData.price_per_unit || priceDetailsData.price
            ),
            isDiscounted: true
        };
    }

    public static fromJson(data: IDiscount): Discount {
        const discount = new Discount();

        copyPropertiesExcludeNullsAndGetters(discount, data);

        const prices = data.prices ? data.prices.map(Discount.priceFromJson) : [];

        const discountDataMapping = {
            discountPercent: data.discount_percent,
            discountApplied: data.discount_applied,
            offerCode: data.offer_code,
            offerMessaging: data.offer_messaging
        };

        copyPropertiesExcludeNullsAndGetters(discount, discountDataMapping);

        discount.prices = prices;

        return discount;
    }
}
